<template>
  <div class="pc-not-find">
    <!--    <div class="pc-tips">{{ tips }}</div>-->
    <!--    <el-link @click="handleOpenDialog">{{ phone }}</el-link>-->
    <div class="not-find-button" @click="handleResolve('1')">
      {{ FinishButton }}
    </div>
    <div class="not-find-button" @click="handleOpenDialog">
      {{ ContactWay }}
    </div>
  </div>
  <el-dialog
    v-model="centerDialogVisible"
    append-to-body
    center
    width="600px"
    custom-class="not-find-dialog"
    :close-on-click-modal="false"
  >
    <div class="pc-dialog-content">
      <div class="pc-dialog-desc">{{ tips }}</div>
      <div class="pc-form-item" v-if="Email">
        <el-image :src="emailIcon"></el-image>
        <span>{{ Email }}</span>
      </div>
      <div class="pc-form-item" v-if="Website">
        <el-image :src="netIcon"></el-image>
        <span>
          <el-link :href="Website" target="_blank">{{ Website }}</el-link>
        </span>
      </div>
      <div class="pc-form-item" v-if="Phone">
        <el-image :src="phoneIcon"></el-image>
        <span>
          {{ Phone }}
        </span>
      </div>
    </div>
  </el-dialog>
</template>

<script>
import { computed, defineComponent, ref } from "vue";
import { ElImage, ElDialog, ElLink } from "element-plus";
import { useRemoteI18n } from "@/utils/useRemoteI18n";
import useOperationRecord from "@/utils/useOperationRecord";

export default defineComponent({
  name: "NotFind",
  components: {
    ElImage,
    ElDialog,
    ElLink,
  },
  setup() {
    /**
     * 联系客服弹窗
     * @type {Ref<UnwrapRef<boolean>>}
     */
    const centerDialogVisible = ref(false);
    const handleOpenDialog = () => {
      // 2 未解决 记录联系客服的浏览记录
      saveNode("2", false);
      centerDialogVisible.value = true;
    };

    // 问题解决请求
    const { saveNode } = useOperationRecord();
    // 国际化文本
    return {
      tips: computed(() => useRemoteI18n("Hint2")),
      ContactWay: computed(() => useRemoteI18n("ContactWay")),
      FinishButton: computed(() => useRemoteI18n("FinishButton")),
      Email: computed(() => useRemoteI18n("Email")),
      Website: computed(() => useRemoteI18n("Website")),
      Phone: computed(() => useRemoteI18n("Phone")),
      emailIcon: require("@/assets/img/email.png"),
      phoneIcon: require("@/assets/img/phone.png"),
      netIcon: require("@/assets/img/net.png"),
      centerDialogVisible,
      handleOpenDialog,
      handleResolve: saveNode,
    };
  },
});
</script>
<style lang="less">
.not-find-dialog {
  .not-find-button {
    cursor: pointer;
    min-width: 120px;
    height: 36px;
    padding: 0 10px;
    border-radius: 4px;
    border: 1px solid #01317d;
    font-size: 14px;
    font-weight: 400;
    color: #01317d;
    line-height: 36px;
    display: flex;
    align-items: center;
    justify-content: center;
    text-align: center;
    transition: all 0.3s;
  }
  .not-find-button:hover {
    color: #fff;
    border-color: #01317d;
    background-color: #01317d;
  }
  .el-dialog__header {
    display: flex;

    .el-dialog__title {
      flex-grow: 1;
      text-align: center;
    }
  }
}
</style>
<style lang="less" scoped>
.pc-not-find {
  border-top: 1px solid #e4e7ed;
  padding: 20px 0;
  text-align: center;
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;
  .not-find-button {
    margin-right: 20px;
    cursor: pointer;
    min-width: 120px;
    height: 42px;
    padding: 0 10px;
    border-radius: 4px;
    border: 1px solid #01317d;
    font-size: 16px;
    font-weight: 400;
    color: #01317d;
    line-height: 22px;
    display: flex;
    align-items: center;
    justify-content: center;
    text-align: center;
    transition: all 0.3s;
  }
  .not-find-button:hover {
    color: #fff;
    border-color: #01317d;
    background-color: #01317d;
  }
  .pc-tips {
    font-size: 16px;
    font-family: PingFangSC-Medium, PingFang SC;
    font-weight: 400;
    color: #666666;
    line-height: 22px;
  }

  .el-link {
    display: flex;
    font-size: 16px;
    font-family: PingFangSC-Regular, PingFang SC;
    font-weight: 400;
    color: #0048b9;
    line-height: 22px;
  }
}

.pc-dialog-content {
  .pc-dialog-desc {
    font-size: 16px;
    font-family: PingFangSC Medium, PingFang SC;
    font-weight: 400;
    color: #333333;
    line-height: 28px;
  }

  .pc-form-item {
    margin-top: 10px;
    display: flex;
    align-items: center;

    .el-image {
      width: 14px;
      height: 14px;
    }

    span {
      margin-left: 10px;
      font-size: 14px;
      font-family: PingFangSC Medium, PingFang SC;
      font-weight: 400;
      color: #333333;
      line-height: 30px;
    }

    .copy {
      cursor: pointer;
      color: #0048b9;
    }
  }
}
</style>
